import Immutable from 'seamless-immutable';
import { getUrlParams, isFormalMeal } from './common-helper';
import { createLastOrderedDishesMgr } from './storage-pair-helper';
import { MemberPrivTypes } from '../helper/const';

import dishMenuMessages from '../intl/messages/dish-menu';
import { formatMessage } from '../intl/helper';
import globalMessages from '../intl/messages/global';

const getUrlParam = (exports.getUrlParam = function(param) {
  const params = getUrlParams() || {};

  return params[param] || null;
});

const isSingleDishWithoutProps = (exports.isSingleDishWithoutProps = dish => {
  if (dish.type === 1) return false;

  const propTypeInfo = dish.dishPropertyTypeInfos || [];
  const ingredientInfos = dish.dishIngredientInfos || [];
  return !ingredientInfos.length && (!propTypeInfo.length || propTypeInfo.every(prop => prop.type === 4 || prop.type === 2));
});

const isGroupDish = (exports.isGroupDish = function(dish) {
  return dish.groups !== undefined;
});

exports.isChildDish = function(dish) {
  return dish.isChildDish;
};

const getOrderedDishes = (exports.getOrderedDishes = function(dishes) {
  return dishes.filter(dish => dish.order > 0 || (dish.order && dish.order.length));
});

const getDishMemberPrice = (exports.getDishMemberPrice = dish => {
  const { marketPrice, discountType, isMember } = dish;
  if (!isMember) {
    // return 0;
    return null;
  }

  let memberPrice = null;
  if (discountType === MemberPrivTypes.DISCOUNT || discountType === MemberPrivTypes.UNIFIED_DISCOUNT) {
    // 折扣1  统一折扣3
    memberPrice = marketPrice * (dish.memberPrice || 0) * 0.1;
  } else if (discountType === MemberPrivTypes.REDUCE) {
    // 固定价 2
    memberPrice = dish.memberPrice || 0;
  }
  if (memberPrice === null) return null; // 如果都不是 则是套餐中加价部分并且没有开启加价折扣
  return +memberPrice.toFixed(2);
});

const getDishesCount = (exports.getDishesCount = function(dishes) {
  if (!Array.isArray(dishes)) return 0;
  const number = dishes
    .map(dish => {
      if (!dish) {
        return 0;
      }
      if (dish.order !== undefined) {
        if (isSingleDishWithoutProps(dish) || !Array.isArray(dish.order)) {
          return Number(dish.order) || 0;
        }
        return dish.order.map(order => Number(order.count) || 0).reduce((c, p) => c + p, 0);
      }
      return 0;
    })
    .reduce((p, c) => p + c, 0);

  return +number.toFixed(4);
});

// 包含变价的价格（做法、加料）
const getOrderPrice = function(dish, orderData) {
  const { marketPrice, saleType } = dish;
  const { dishPropertyTypeInfos = [], dishIngredientInfos = [], count, groups = [] } = orderData;
  const isWeighedMode = saleType === 1;

  // 套餐价格计算
  if (isGroupDish(dish)) {
    // 称重模式下的配料价格总计
    // 选中的子菜
    const checkedChildDishes = groups.reduce((list, group) => list.concat(group.childInfos.filter(childDish => childDish.order)), []);
    // 子菜的价格列表
    const prices = checkedChildDishes.map(item => {
      const isSingle = isSingleDishWithoutProps(item);
      let price = 0;

      if (isSingle) {
        price = item.marketPrice * item.order;
      } else {
        price = item.order.map(dishOrder => getOrderPrice(item, dishOrder)).reduce((c, p) => c + p, 0);
      }

      return price;
    });

    return (count * (marketPrice + prices.reduce((c, p) => c + p, 0))).toFixed(2);
  }

  // 不是套餐的计算
  // 不算备注的做法列表
  const allProps = dishPropertyTypeInfos.filter(prop => prop.type !== 3).reduce((list, item) => list.concat(item.properties || []), []);
  // 勾选的做法总价
  const checkedPropsPrice = allProps
    .filter(prop => prop.isChecked)
    .map(prop => prop.reprice || 0)
    .reduce((c, p) => c + p, 0);
  // 勾选的配料总价，暂时没有一份菜对应多个配料(item.num)
  const checkedIngredientsPrice = dishIngredientInfos
    .filter(item => item.isChecked)
    .map(item => item.reprice || 0)
    .reduce((c, p) => c + p, 0);

  let price = 0;

  // 计算称重商品配料的价格不需要乘上菜品的份数
  if (isWeighedMode) {
    price = count * marketPrice + checkedPropsPrice + checkedIngredientsPrice;
  } else {
    price = count * (marketPrice + checkedPropsPrice + checkedIngredientsPrice);
  }

  price = parseFloat(price.toFixed(2), 10);
  return Math.max(price, 0);
};

exports.getOrderPrice = getOrderPrice;

const getDishPrice = function(dish) {
  if (isSingleDishWithoutProps(dish)) {
    const singleDishPrice = parseFloat((dish.marketPrice * dish.order).toFixed(2));
    return singleDishPrice >= 0 ? singleDishPrice : 0;
  }

  const hasPropsDishPrice = dish.order.map(eachOrder => parseFloat(getOrderPrice(dish, eachOrder))).reduce((c, p) => c + p, 0);
  return hasPropsDishPrice >= 0 ? hasPropsDishPrice : 0;
};

exports.getDishPrice = getDishPrice;

//
exports.getActivityBenefitMaxId = function(dishes) {
  // 在活动优惠中选取最大优惠价
  let activityBenefitMaxId = 0, // 活动优惠最大的菜品id
    activityBenefitMaxValue = 0, // 活动优惠最大的菜品优惠价
    activityBenefitMaxIdList = [], // 参与活动优惠的商品id列表
    activityBenefitMaxValList = [], // 参与活动优惠的商品优惠价列表
    activityBenefitMaxlocation = -1, // 活动优惠最大的菜品在优惠价列表中的位置
    singleMarketObj = null,
    singleMarketingInfosPrice = 0,
    singleMarketingInfosMaxPrice = 0,
    singleMarketPriceList = [];
  // 遍历已经点好的菜品找出优惠最多的菜品
  if (dishes && dishes.length) {
    for (let k = 0; k < dishes.length; k++) {
      // 活动优惠中的单商品菜品
      if (dishes[k].activityBenefit) {
        activityBenefitMaxValList.push(dishes[k].activityBenefit);
        activityBenefitMaxIdList.push(dishes[k].id);
      } else if (dishes[k].order instanceof Array && dishes[k].order[0].activityBenefit) {
        // 活动优惠中的套餐菜品
        activityBenefitMaxValList.push(dishes[k].order[0].activityBenefit);
        activityBenefitMaxIdList.push(dishes[k].id);
      }
      // 活动优惠中的单商品折扣
      if (dishes[k].singleMarketingInfos && dishes[k].singleMarketingInfos instanceof Array && dishes[k].singleMarketingInfos.length) {
        // 添加单品折扣优惠价格比较
        // 遍历一个菜品中所有单商品折扣方式并找出满减和打折中优惠最多的一个
        for (let i = 0; i < dishes[k].singleMarketingInfos.length; i++) {
          singleMarketObj = dishes[k].singleMarketingInfos[i];
          // singleMarketingInfosPrice = singleMarketObj.type == 1 ? singleMarketObj.value : (singleMarketObj.type == 2 ? dishes[k].marketPrice - Number(dishes[k].marketPrice / 10 * singleMarketObj.value).toFixed(2) : 0 );
          if (singleMarketObj.type == 1) {
            // 单商品折扣满减
            singleMarketingInfosPrice = singleMarketObj.value;
          } else if (singleMarketObj.type == 2) {
            // 单商品折扣打折
            if (dishes[k].memberPrice) {
              // 单商品折扣非套餐的情况下
              if (dishes[k].order && !dishes[k].order.length) {
                singleMarketingInfosPrice = dishes[k].memberPrice - ((dishes[k].memberPrice / 10) * singleMarketObj.value).toFixed(2);
              }
            } else {
              singleMarketingInfosPrice = dishes[k].marketPrice - Number((dishes[k].marketPrice / 10) * singleMarketObj.value).toFixed(2);
            }
          } else {
            singleMarketingInfosPrice = 0;
          }
          singleMarketPriceList.push(singleMarketingInfosPrice);
        }
        singleMarketingInfosMaxPrice = Math.max(...singleMarketPriceList);
        if (activityBenefitMaxValList.indexOf(singleMarketingInfosMaxPrice) == -1) {
          activityBenefitMaxValList.push(singleMarketingInfosMaxPrice);
          activityBenefitMaxIdList.push(dishes[k].id);
        }
      }
    }
    if (activityBenefitMaxValList.length > 0) {
      activityBenefitMaxValue = Math.max(...activityBenefitMaxValList);
      activityBenefitMaxlocation = activityBenefitMaxValList.indexOf(activityBenefitMaxValue);
      activityBenefitMaxId = activityBenefitMaxIdList[activityBenefitMaxlocation];
    }
  }
  // 返回活动优惠中最大优惠菜品的id 和 优惠价格
  return {
    activityBenefitMaxId,
    activityBenefitMaxValue,
  };
};

// calcOption 参数废弃
// memberPrice: boolean
const getDishesPrice = function(dishes, calcOption, memberPrice) {
  const dishesPrice = dishes
    .map(dish => {
      const newDish = dish.asMutable ? dish.asMutable() : { ...dish }; // 构建新的对象
      const memberPriceStr = newDish.memberPrice !== null && newDish.memberPrice !== undefined ? newDish.memberPrice.toString() : null; // 消除memberPrice为0的影响
      if (memberPrice && memberPriceStr) {
        // if (memberPrice && newDish.memberPrice) {
        // 使用会员价
        newDish.marketPrice = getDishMemberPrice(newDish);
      }
      return getDishPrice(newDish);
    })
    .reduce((c, p) => c + p, 0);
  if (isFinite(dishesPrice) && Math.floor(dishesPrice) === dishesPrice) {
    return dishesPrice;
  }
  return parseFloat(dishesPrice.toFixed(2));
};
exports.getDishesPrice = getDishesPrice;

/**
 * getRealMarketPrice
 * @param { dish }
 * 考虑到菜品变价为负的情况，基准价>实际价格
 */

exports.getRealMarketPrice = dish => {
  return Math.min(dish.marketPrice, getDishPrice(dish));
};

/**
 * 计算菜品基准价
 */
const getDishMarketPrice = dish => {
  if (isSingleDishWithoutProps(dish)) {
    return Math.max(0, dish.marketPrice * dish.order);
  }
  return (dish.order || []).map(order => dish.marketPrice * order.count).reduce((p, c) => p + c, 0);
};

/**
 * 计算菜品基准价总和
 */
exports.getDishesMarketPrice = dishes => {
  const amount = (dishes || []).map(dish => getDishMarketPrice(dish)).reduce((p, c) => p + c, 0);
  return parseFloat(amount.toFixed(2), 10);
};

exports.getNewCountOfDish = function(dish, increment, newDish = {}) {
  let newCount = 0;

  if (isSingleDishWithoutProps(dish)) {
    if (dish.order === undefined) {
      newCount = newDish.order || dish.dishIncreaseUnit;
    } else if (dish.order + increment < dish.dishIncreaseUnit) {
      newCount = undefined;
    } else {
      newCount = dish.order + increment;
    }
    newCount = newCount <= 0 ? undefined : newCount;
  } else {
    const oldCount = getDishesCount([dish]);
    if (oldCount === 0) {
      // if never ordered this dish;
      newCount = dish.dishIncreaseUnit;
    } else if (oldCount + increment < dish.dishIncreaseUnit) {
      // if never ordered this dish and now want to order a count that is smaller thant dishIncreaseUnit;
      newCount = 0;
    } else {
      newCount = oldCount + increment;
    }
  }

  return newCount;
};

const getOrderPropIds = function(order) {
  const { dishPropertyTypeInfos, dishIngredientInfos } = order;
  const propsIds = [].concat.apply([], dishPropertyTypeInfos.map(prop => prop.properties.filter(property => property.isChecked).map(property => property.id)));
  const ingredientIds = (dishIngredientInfos || []).filter(ingredient => ingredient.isChecked).map(ingredient => ingredient.id);
  return [propsIds, ingredientIds];
};

const getSignleDishRuleIds = function(dish) {
  let rulePropertyCollection = [];
  dish.dishPropertyTypeInfos.map(property => property.properties.map(prop => rulePropertyCollection.push(prop.id)));
  return rulePropertyCollection.join('^');
};

const getDishBoxCount = (exports.getDishBoxCount = function(orderedDishes) {
  let dishBoxContainer = [];
  orderedDishes.map(orderDish => {
    if (isGroupDish(orderDish)) {
      orderDish.order.map(childOrder => {
        const count = childOrder.count;
        // let childDishCount = 0; // 判定所有子菜的餐盒费
        childOrder.groups.map(group =>
          group.childInfos
            .filter(childDish => childDish.order)
            .map(child => {
              if (child.boxQty && child.dishQty) {
                // 计算了子菜的餐盒费
                dishBoxContainer.push(Math.ceil(getDishesCount([child]) / parseFloat(child.dishQty)) * parseFloat(child.boxQty) * count);
                // childDishCount += child.boxQty;
              } else {
                return false;
              }
              return true;
            }),
        );
        // 如何判定所有子菜都没有餐盒费
        // console.log('mmm', childDishCount);
        // if (childDishCount === 0 && orderDish.dishQty) { // 把套餐的餐盒费计算在内,所有子菜都不需要餐盒费
        //   dishBoxContainer.push(childOrder.count * orderDish.dishQty);
        // }
      });
    } else {
      if (orderDish.boxQty && orderDish.dishQty) {
        dishBoxContainer.push(Math.ceil(getDishesCount([orderDish]) / parseFloat(orderDish.dishQty)) * parseFloat(orderDish.boxQty));
      }
    }
    return true;
  });
  return dishBoxContainer.reduce((c, p) => c + p, 0);
});

exports.getDishBoxprice = function(orderedDishes, dishBoxChargeInfo) {
  if (!dishBoxChargeInfo || dishBoxChargeInfo.orderFlag !== 1) {
    return 0;
  }
  return getDishBoxCount(orderedDishes) * dishBoxChargeInfo.content;
};

const hasSelectedProps = (exports.hasSelectedProps = function(dish) {
  const [order] = dish.order;
  const hasProps = (order.dishPropertyTypeInfos || []).some(prop => prop.type !== 4 && prop.type !== 2 && (prop.properties || []).some(item => item.isChecked));
  const hasIngredients = (order.dishIngredientInfos || []).some(item => item.isChecked);

  if (hasProps || hasIngredients) return true;
  return false;
});

// setCookie
const setCookie = (exports.setCookie = function(name, value) {
  const Days = 30;
  const exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${exp.toGMTString()};path=/`;
});

const getDishCookieObject = (exports.getDishCookieObject = function(dish, orderIdx) {
  const isSingleDish = !isGroupDish(dish);
  const consumeType = getUrlParam('type');
  const shopId = getUrlParam('shopId');
  const { id, marketPrice } = dish;
  const orderCount = isSingleDishWithoutProps(dish) ? getDishesCount([dish]) : dish.order[orderIdx].count;
  if (isSingleDish) {
    let spliceResultOfPropIds = null;
    if (isSingleDishWithoutProps(dish)) {
      if (dish.dishPropertyTypeInfos && dish.dishPropertyTypeInfos.length) {
        // 到这里就剩下只有规格的菜品了
        spliceResultOfPropIds = `-${getSignleDishRuleIds(dish)}`;
      } else {
        spliceResultOfPropIds = '-';
      }
    } else {
      spliceResultOfPropIds = `${getOrderPropIds(dish.order[orderIdx])[1].join('^')}-${getOrderPropIds(dish.order[orderIdx])[0].join('^')}`;
    }
    return { key: `${consumeType}_${shopId}_${id}_${id}|1-${spliceResultOfPropIds}`, value: `${orderCount}|${marketPrice}` };
  }
  const splitPropsIds = [].concat.apply(
    [],
    dish.order[orderIdx].groups.map(group => {
      const groupId = group.id;
      const result = group.childInfos
        .filter(childInfos => getDishesCount([childInfos]))
        .map(childInfo => {
          let spliceResultOfPropIds = null;
          if (isSingleDishWithoutProps(childInfo)) {
            if (childInfo.dishPropertyTypeInfos && childInfo.dishPropertyTypeInfos.length) {
              // 到这里就剩下只有规格的菜品了
              spliceResultOfPropIds = `-${getSignleDishRuleIds(childInfo)}`;
            } else {
              spliceResultOfPropIds = '-';
            }
          } else {
            spliceResultOfPropIds = `${getOrderPropIds(childInfo.order[0])[1].join('^')}-${getOrderPropIds(childInfo.order[0])[0].join('^')}`;
          }
          return `${childInfo.id}A${groupId}|${getDishesCount([childInfo])}-${spliceResultOfPropIds}`;
        });
      return [].concat.apply([], result);
    }),
  );
  const groupChildDishIds = !splitPropsIds.join('#') || splitPropsIds.join('#') === '' ? id + '|1--' : splitPropsIds.join('#');
  return { key: `${consumeType}_${shopId}_${id}_${groupChildDishIds}`, value: `${orderCount}|${marketPrice}` };
});

const dishesLocalStorageMgr = createLastOrderedDishesMgr();

exports.storeDishesLocalStorage = function(data, shopInfo, func) {
  const dishes = func ? func(data) : getOrderedDishes(data);
  const options = {
    shopId: getUrlParam('shopId'),
    shopName: shopInfo.commercialName || '',
    type: getUrlParam('type'),
  };

  dishesLocalStorageMgr.set(dishes, options);
};

exports.clearDishesLocalStorage = function() {
  dishesLocalStorageMgr.clear();
};

exports.restoreDishesLocalStorage = function(data) {
  const shopId = getUrlParam('shopId');
  const type = getUrlParam('type');
  const dishes = dishesLocalStorageMgr.get({ shopId, type });
  if (!dishes) {
    return data;
  }

  data.dishList.forEach(dish => {
    const orderedDishIndex = dishes.findIndex(orderedDish => orderedDish.id === dish.id);
    if (orderedDishIndex > -1) {
      dish.order = dishes[orderedDishIndex].order;
    }
  });

  return data;
};

exports.getDishesLocalStorage = args => {
  const dishes = dishesLocalStorageMgr.get(args);

  return dishes ? { dishes } : null;
};

const appendzero = (exports.appendzero = number => {
  if (number < 10) {
    return '0' + number;
  }
  return number;
});

exports.isShopOpen = function(timeList = []) {
  const now = new Date();
  const currentTime = `${appendzero(now.getHours())}:${appendzero(now.getMinutes())}`;

  let shopOpen = false;
  timeList.forEach((item, index) => {
    if (currentTime >= item.startTime && currentTime <= item.endTime && !shopOpen) {
      shopOpen = true;
    }
  });

  return shopOpen;
};
exports.setDishCookie = (dishesData, orderedData) => {
  // 下面开始区分套餐cookie和单品菜cookie
  orderedData.map(orderData => {
    if (!isSingleDishWithoutProps(orderData)) {
      for (let index in orderData.order) {
        const setPackageDishCookie = getDishCookieObject(orderData, index);
        setCookie(setPackageDishCookie.key, setPackageDishCookie.value);
      }
      return true;
    }
    const setSignleDishCookie = getDishCookieObject(orderData, 0);
    return setCookie(setSignleDishCookie.key, setSignleDishCookie.value);
  });
};
exports.deleteOldDishCookie = function() {
  const oldCookieCollection = document.cookie.match(/(WM|TS).+?((?=;)|$)/g);
  if (oldCookieCollection && oldCookieCollection.length) {
    oldCookieCollection.forEach(cookie => {
      let date = new Date();
      date.setTime(date.getTime() - 10000);
      document.cookie = cookie + '=a; expires=' + date.toGMTString() + '; path=/';
    });
  }
};

exports.generateDishNameWithUnit = (dishData, entry) => {
  if (Array.isArray(dishData.dishPropertyTypeInfos) && dishData.dishPropertyTypeInfos.length) {
    const avaliableDishProps = dishData.dishPropertyTypeInfos.filter(prop => prop.type === 4);
    if (avaliableDishProps.length) {
      const properties = avaliableDishProps
        .map(prop => {
          const [cur] = prop.properties;
          return cur && cur.name;
        })
        .join(', ');
      // return dishData.unitName ? `${dishData.name}(${properties})/${dishData.unitName}` : `${dishData.name}(${properties})`;
      switch (entry) {
        case 'dishMenu':
          return dishData.unitName !== '份' ? `${dishData.name}(${properties})/${dishData.unitName}` : `${dishData.name}(${properties})`;
        default:
          return `${dishData.name}(${properties})`;
      }
    }
    // return dishData.unitName ? `${dishData.name}/${dishData.unitName}` : dishData.name;
    switch (entry) {
      case 'dishMenu':
        return dishData.unitName !== '份' ? `${dishData.name}/${dishData.unitName}` : dishData.name;
      default:
        return dishData.name;
    }
  }
  // return dishData.unitName ? `${dishData.name}/${dishData.unitName}` : dishData.name;
  switch (entry) {
    case 'dishMenu':
      return dishData.unitName !== '份' ? `${dishData.name}/${dishData.unitName}` : dishData.name;
    default:
      return dishData.name;
  }
};

exports.formatOpenTime = openTimeList => {
  let openTimeContent = '';
  // const resultObj = {};
  if (openTimeList && Array.isArray(openTimeList) && openTimeList.length !== 0) {
    const newOpenTimeList = [].slice.call(openTimeList); // 新数组
    let timeRange = '';
    const ignoreNum = [];
    openTimeList.forEach((item, index) => {
      newOpenTimeList.splice(0, 1); // 去掉数组头
      if (ignoreNum.indexOf(index) !== -1) {
        return;
      }
      let basicStartTime = item.startTime; // 初始开始数据
      let basicEndTime = item.endTime; // 初始结束数据

      newOpenTimeList.forEach((newitem, newindex) => {
        // 子循环
        // 如果时间有交集 分几种情况
        switch (true) {
          case newitem.startTime <= basicEndTime && newitem.startTime >= basicStartTime:
            if (newitem.endTime >= basicEndTime) {
              // 有交集
              basicEndTime = newitem.endTime;
            }
            ignoreNum.push(newindex + index + 1);
            break;
          case newitem.startTime <= basicStartTime:
            if (newitem.endTime >= basicStartTime && newitem.endTime <= basicEndTime) {
              // 有交集
              basicStartTime = newitem.startTime;
              ignoreNum.push(newindex + index + 1);
            } else if (newitem.endTime >= basicEndTime) {
              basicStartTime = newitem.startTime;
              basicEndTime = newitem.endTime;
              ignoreNum.push(newindex + index + 1);
            }
            break;
          default:
            break;
        }
      });
      timeRange = `${basicStartTime.slice(0, 5)}-${basicEndTime.slice(0, 5)}`;
      openTimeContent += `${timeRange} `;
    });
  }
  return openTimeContent;
};

exports.formatMarket = (marketList, formatDishesData) => {
  const formatMarket = {};
  marketList.forEach((item, index) => {
    const dishId = item.dishId;
    if (item.rules && item.rules.length !== 0 && formatDishesData[dishId]) {
      formatMarket[dishId] = item.rules;
    }
  });
  return formatMarket;
};

exports.formatMarketUpdate = (marketList, formatDishesData) => {
  const formatMarketUpdate = [];
  // 外部排序
  marketList.forEach((item, index) => {
    const dishId = item.dishId;
    const dish = formatDishesData[dishId];

    if (item.rules && item.rules.length !== 0 && dish) {
      item.rules.forEach((itemt, indext) => {
        formatMarketUpdate.push(itemt);
      });
    }
  });

  return formatMarketUpdate.sort((a, b) => {
    if (b.updateTime > a.updateTime) {
      return 1;
    } else if (b.updateTime === a.updateTime) {
      return 0;
    }
    return -1;
  });
};

exports.formatDishesData = dishesData => {
  const formatDishesData = {};
  dishesData.forEach((item, index) => {
    formatDishesData[item.brandDishId] = item;
  });
  return formatDishesData;
};

exports.matchDishesData = (marketListUpdate, formatDishesData) => {
  let marketMatchDishes = false;
  marketListUpdate.forEach((item, index) => {
    if (formatDishesData[item.dishId]) {
      marketMatchDishes = true;
    }
  });
  return marketMatchDishes;
};

/*
  合并名称,销售单位,商品中类一致,商品参与的规格分组完全一致的菜品
*/
exports.mergeSameRuleDish = (dishList, dishTypeList) => {
  if (!dishList || !dishList.length) {
    return { dishList: [], dishTypeList };
  }

  const mergedDishList = [];
  const sameRuleDishMap = {};
  const getDishRuleFlag = dish => {
    const ids = dish.dishPropertyTypeInfos.filter(item => item.type === 4).map(item => item.properties[0].id);
    return ids.sort().join('-');
  };

  dishList.forEach((dish, index) => {
    if (dish.saleType === 1) {
      Object.assign(dish, { stepNum: 1, dishIncreaseUnit: 1 });
    }

    // snail 2019-06-13 无论是什么售卖类型，都将做stepNum及dishIncreaseUnit 默认为1 向下求整的逻辑。
    let { stepNum, dishIncreaseUnit } = dish;
    if (!stepNum) stepNum = 1;
    if (!dishIncreaseUnit) dishIncreaseUnit = 1;

    stepNum = isNaN(stepNum) ? stepNum : Math.floor(stepNum) === 0 ? 1 : Math.floor(stepNum);
    dishIncreaseUnit = isNaN(dishIncreaseUnit) ? dishIncreaseUnit : Math.floor(dishIncreaseUnit) === 0 ? 1 : Math.floor(dishIncreaseUnit);

    Object.assign(dish, { stepNum, dishIncreaseUnit });

    if (isGroupDish(dish)) {
      mergedDishList.push(dish);
      return;
    }

    const ruleIdStr = dish.dishPropertyTypeInfos
      .filter(item => item.type === 4)
      .map(item => {
        const firstProperty = item.properties && item.properties[0];
        if (firstProperty) {
          firstProperty.isChecked = true;
        }
        return item.id;
      })
      .join('-');
    const key = `${dish.name}-${dish.unitName}-${dish.dishTypeId}-${ruleIdStr}`;

    sameRuleDishMap[key] = (sameRuleDishMap[key] || []).concat([index]);
    dish.dishIngredientInfos = dish.dishIngredientInfos.map(item => ({ ...item, isChecked: !!item.isChecked }));
    mergedDishList.push(dish);
  });

  for (const key in sameRuleDishMap) {
    if (!sameRuleDishMap.hasOwnProperty(key)) {
      continue;
    }

    const sameDishIndexs = sameRuleDishMap[key];
    if (sameDishIndexs.length <= 1) {
      continue;
    }

    const marketPrices = [];
    sameDishIndexs.forEach(dishIndex => {
      const sameDish = dishList[dishIndex];
      sameDish.ruleFlag = getDishRuleFlag(sameDish);
      marketPrices.push(sameDish.marketPrice);
    });

    const minMarketPirice = Math.min.apply(null, marketPrices);
    const maxMarketPirice = Math.max.apply(null, marketPrices);
    let firstDishId = '';

    sameDishIndexs.forEach((dishIndex, index) => {
      const dish = mergedDishList[dishIndex];
      if (index === 0) {
        firstDishId = dish.id;
        Object.assign(dish, { sameDishIndexs, mergedMinPrice: minMarketPirice === maxMarketPirice ? undefined : minMarketPirice });
        return;
      }

      Object.assign(dish, { proxyDishId: firstDishId });
    });
  }

  return {
    dishList: mergedDishList,
    dishTypeList,
  };
};

exports.organizeDishData = dish => {
  const dishData = {};
  dishData.id = dish.id;
  dishData.name = dish.name;
  dishData.dishTypeId = dish.dishTypeId;
  dishData.brandDishId = dish.brandDishId;
  dishData.type = dish.type;
  dishData.marketPrice = dish.marketPrice;
  dishData.unitName = dish.unitName;
  dishData.dishIncreaseUnit = dish.dishIncreaseUnit;
  dishData.stepNum = dish.stepNum;
  dishData.dishTypeName = formatMessage(globalMessages.defaultSort);
  dishData.dishTypeOrder = 0;
  dishData.saleType = dish.saleType;
  dishData.proxyDishId = dish.proxyDishId;

  // 菜品属性
  const fillPropertyTypeList = (propertyTypeList, dishType) => {
    if (!propertyTypeList || !propertyTypeList.length) {
      return [];
    }

    return propertyTypeList.map(propertyType => {
      const { name, type, id, properties } = propertyType;
      return { id, name, type, properties: dishType === 'number' ? properties : properties.filter(item => item.isChecked) };
    });
  };

  const dishTypeList = JSON.parse(sessionStorage.dishTypeList || '[]');

  dishTypeList.forEach(item => {
    if (item.id === dish.dishTypeId) {
      dishData.dishTypeName = item.name;
      // dishData.dishTypeOrder = item.desc || 0;
      dishData.dishTypeOrder = 0;
    }
  });

  // 菜品配料
  const fillDishIngredientInfos = dishIngredientInfos => (dishIngredientInfos || []).filter(item => item.isChecked);

  if (isSingleDishWithoutProps(dish)) {
    dishData.num = dish.order;
    dishData.propertyTypeList = dish.dishPropertyTypeInfos || [];
    dishData.dishIngredientInfos = dish.dishIngredientInfos || [];
  } else if (isGroupDish(dish)) {
    const [order] = dish.order;

    dishData.num = order.count;
    dishData.subDishItems = [];
    order.groups.forEach(group => {
      // 分组的子菜遍历
      group.childInfos.forEach(childInfo => {
        if (!childInfo.order) {
          return;
        }
        let num = getDishesCount([childInfo]);
        if (!num) {
          return;
        }

        // const orderedChildDish = {};
        // orderedChildDish.groupId = group.id;
        // orderedChildDish.num = num;
        // orderedChildDish.itemId = childInfo.id;
        // orderedChildDish.name = childInfo.name;
        // orderedChildDish.marketPrice = childInfo.marketPrice;
        // orderedChildDish.unitName = childInfo.unitName;

        // let ingredientInfoList = childInfo.dishIngredientInfos;
        // let propertyTypeInfoList = childInfo.dishPropertyTypeInfos;
        // if (typeof childInfo.order !== 'number') {
        //   let ingredientInfoListTemp = childInfo.order.map((item) => item.dishIngredientInfos);
        //   if (ingredientInfoListTemp) {
        //     ingredientInfoList = ingredientInfoListTemp[0] || [];
        //   }
        //   let propertyTypeInfoListTemp = childInfo.order.map((item) => item.dishPropertyTypeInfos);
        //   if (propertyTypeInfoListTemp) {
        //     propertyTypeInfoList = propertyTypeInfoListTemp[0] || [];
        //   }
        // }

        // orderedChildDish.propertyTypeList = fillPropertyTypeList(propertyTypeInfoList || []);
        // orderedChildDish.dishIngredientInfos = fillDishIngredientInfos(ingredientInfoList || []);
        // dishData.subDishItems.push(orderedChildDish);

        // 遍历order -- 改
        if (typeof childInfo.order !== 'number') {
          childInfo.order.map(item => {
            if (item.count === 0) return false;
            const orderedChildDish = {};
            orderedChildDish.groupId = group.id;
            orderedChildDish.itemId = childInfo.id;
            orderedChildDish.name = childInfo.name;
            orderedChildDish.marketPrice = childInfo.marketPrice;
            orderedChildDish.unitName = childInfo.unitName;
            orderedChildDish.num = item.count;
            orderedChildDish.saleType = childInfo.saleType;
            orderedChildDish.propertyTypeList = fillPropertyTypeList(item.dishPropertyTypeInfos || []);
            orderedChildDish.dishIngredientInfos = fillDishIngredientInfos(item.dishIngredientInfos || []);
            dishData.subDishItems.push(orderedChildDish);
            return true;
          });
        } else {
          const orderedChildDish = {};
          orderedChildDish.groupId = group.id;
          orderedChildDish.num = num;
          orderedChildDish.itemId = childInfo.id;
          orderedChildDish.name = childInfo.name;
          orderedChildDish.marketPrice = childInfo.marketPrice;
          orderedChildDish.unitName = childInfo.unitName;
          orderedChildDish.saleType = childInfo.saleType;
          orderedChildDish.propertyTypeList = fillPropertyTypeList(childInfo.dishPropertyTypeInfos || [], 'number');
          orderedChildDish.dishIngredientInfos = fillDishIngredientInfos(childInfo.dishIngredientInfos || []);
          dishData.subDishItems.push(orderedChildDish);
        }
      });
    });
  } else {
    const [order] = dish.order;

    dishData.num = order.count;
    dishData.propertyTypeList = fillPropertyTypeList(order.dishPropertyTypeInfos);
    dishData.dishIngredientInfos = fillDishIngredientInfos(order.dishIngredientInfos);
  }
  const time = new Date();
  return Object.assign({}, dishData, { tag: time.getTime() });
};

exports.adjustOrderedDishIncrement = (dish, increment, newDish = {}) => {
  if (isSingleDishWithoutProps(dish)) {
    const order = dish.order || newDish.order || 0;
    const { dishIncreaseUnit = 1, stepNum = 1 } = dish;
    if (increment > 0 && order === 0) {
      return increment === stepNum ? dishIncreaseUnit : increment;
    }

    const calculdatedOrder = order + increment;
    if (calculdatedOrder <= 0) {
      return -order;
    }

    if (calculdatedOrder < dishIncreaseUnit) {
      return dishIncreaseUnit * (Math.abs(increment) / increment);
    }
  }

  return increment;
};

exports.getDishMemberPriceWithSameRuleDishes = (dish, sameRuleDishes) => {
  if (!sameRuleDishes) {
    return getDishMemberPrice(dish);
  }

  const memberDishPrices = [];
  sameRuleDishes.forEach(item => {
    if (dish.marketPrice === item.marketPrice && item.isMember) {
      memberDishPrices.push(getDishMemberPrice(item));
    }
  });
  return Math.min.apply(null, memberDishPrices);
};

exports.containsSubPropertyDetail = dish => {
  if (isSingleDishWithoutProps(dish)) {
    return false;
  }

  if (!isGroupDish(dish)) {
    return hasSelectedProps(dish);
  }

  const [order] = dish.order || [];
  if (!order) {
    return false;
  }

  const { groups = [] } = order;
  return groups.some(group => group.childInfos.some(child => getDishesCount([child]) > 0));
};

const ballFlyAnimationTimer = {
  queue: [],
  current: null,
};

const ballFlyWhenOrderDish = (exports.ballFlyWhenOrderDish = options => {
  if (ballFlyAnimationTimer.isSingle === undefined) {
    ballFlyAnimationTimer.isSingle = navigator.userAgent.toLowerCase().indexOf('android') !== -1;
  }

  if (ballFlyAnimationTimer.isSingle && ballFlyAnimationTimer.current) {
    ballFlyAnimationTimer.queue = [options];
    return;
  }

  ballFlyAnimationTimer.current = options;
  const settings = Object.assign(
    {
      vertexRtop: 20,
      speed: 2.8,
      start: {},
      end: {},
    },
    options,
  );

  const init = () => {
    document.body.insertAdjacentHTML('beforeend', `<ins class='${settings.className || ''}'></ins>`);
    settings.elem = document.body.lastChild;
    const { start, end, vertexRtop } = settings;

    let vertexTop = Math.min(start.top, end.top) - Math.abs(start.left - end.left) / 13;
    if (vertexTop < vertexRtop) {
      vertexTop = Math.min(vertexRtop, Math.min(start.top, end.top));
    }
    const distance = Math.sqrt(Math.pow(start.top - end.top, 2) + Math.pow(start.left - end.left, 2));
    const steps = Math.ceil(Math.min(Math.max(Math.log(distance) / 0.05 - 75, 30), 100) / settings.speed);
    const ratio = start.top === vertexTop ? 0 : -Math.sqrt((end.top - vertexTop) / (start.top - vertexTop));
    const vertexLeft = (ratio * start.left - end.left) / (ratio - 1);
    const curvature = end.left === vertexLeft ? 0 : (end.top - vertexTop) / Math.pow(end.left - vertexLeft, 2);

    Object.assign(settings, {
      count: -1,
      steps,
      vertexLeft,
      vertexTop,
      curvature,
    });
    Object.assign(settings.elem.style, {
      left: `${settings.start.left}px`,
      top: `${settings.start.top}px`,
    });
  };

  const destory = () => {
    ballFlyAnimationTimer.current = null;
    settings.elem.parentNode.removeChild(settings.elem);
    settings.elem = null;
  };

  const queue = () => {
    const next = ballFlyAnimationTimer.queue.shift();
    if (next) {
      ballFlyWhenOrderDish(next);
    }
  };

  const move = () => {
    const { start, steps, count, end } = settings;
    const left = start.left + ((end.left - start.left) * count) / steps;
    const top =
      settings.curvature === 0
        ? start.top + ((end.top - start.top) * count) / steps
        : settings.curvature * Math.pow(left - settings.vertexLeft, 2) + settings.vertexTop;
    settings.elem.style.transform = `translate3d(${left - start.left}px,${top - start.top}px,0)`;
    settings.count++;

    const time = window.requestAnimationFrame(move);
    if (count === steps) {
      window.cancelAnimationFrame(time);
      destory();
      queue();

      if (settings.onEnd) {
        setTimeout(() => {
          settings.onEnd();
        }, 20);
      }
    }
  };
  init();
  move();
});

exports.divideOrderedDishes = (dishes, func = () => null) =>
  [].concat.apply(
    [],
    dishes.map(dish => {
      if (isSingleDishWithoutProps(dish)) {
        return [Object.assign({}, dish, func(dish))];
      }
      return dish.order.map((dishOrder, idx) => Object.assign({}, dish, func(dish), { order: [Object.assign({}, dishOrder)] }));
    }),
  );

/**
 * 菜品打折数据去重
 */
exports.uniqueDiscountInfo = dishList => {
  const list = [];
  const uniqueIdMap = {};

  (dishList || []).forEach(dish => {
    const { dishId: id } = dish;
    if (!uniqueIdMap.hasOwnProperty(id)) {
      uniqueIdMap[id] = true;
      list.push(dish);
    }
  });
  return list;
};

/**
 * 配料属性
 */
exports.formatMemo = mainDish => {
  // 合并配料与菜品属性 BEGIN
  const dishIngredientList = mainDish.dishIngredientInfos || [];
  let propertyTypeList = mainDish.propertyTypeList || [];
  let dishIngredientArray = [];

  if (dishIngredientList && dishIngredientList.length !== 0) {
    dishIngredientArray = [
      {
        name: formatMessage(dishMenuMessages.ingredients),
        type: 2.5,
        properties: dishIngredientList,
      },
    ];
  }
  propertyTypeList = propertyTypeList.concat(dishIngredientArray);
  // 合并配料与菜品属性 END

  if (!propertyTypeList || propertyTypeList.length === 0) {
    return '';
  }
  let memoList = (propertyTypeList || []).filter(item => item.type !== 4);
  memoList = Array.prototype.slice.call(memoList).sort((a, b) => a.type - b.type); // 按照 口味-标签-备注 进行排序
  let memo = '';
  memoList.forEach((item, index) => {
    if (item.type === 1 || item.type === 2 || item.type === 3 || item.type === 2.5) {
      // 口味做法
      memo += ` | ${item.name}:`;
    }
    (item.properties || []).forEach((itemt, indext) => {
      if (itemt.name) {
        if (item.type === 2.5) {
          // 配料需要加上*num
          memo += `${itemt.name}x${itemt.num || 1},`;
        } else {
          memo += `${itemt.name},`;
        }
      }
    });
    memo = memo.substring(0, memo.length - 1);
  });
  memo = memo.substring(2, memo.length);
  return memo;
};

const TS_AD_SHOW_KEY = 'fullscreen-ad-display-time';
const SELECT_PEOPLE_KEY = 'select-people-flag';

const getSelectPeopleFlag = () => {
  const fromSelectPeople = getUrlParam('fromSelectPeople');
  const now = new Date();
  const today = `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`;

  const DISH_KEY = `dish-${today}`;
  const PEOPLE_KEY = `people-${today}`;
  const selectPeopleFlag = JSON.parse(window.localStorage.getItem(SELECT_PEOPLE_KEY)) || {};

  let dishNum = selectPeopleFlag[DISH_KEY];
  let peopleNum = selectPeopleFlag[PEOPLE_KEY];
  dishNum = dishNum ? dishNum + 1 : 1;
  if (fromSelectPeople === 'true') {
    peopleNum = peopleNum ? peopleNum + 1 : 1;
  }
  const latestFlag = {
    [DISH_KEY]: dishNum,
    [PEOPLE_KEY]: peopleNum,
  };
  window.localStorage.setItem(SELECT_PEOPLE_KEY, JSON.stringify(latestFlag));

  return {
    dishNum,
    peopleNum,
  };
};

exports.getFullscreenAdShow = function({ fullAdvertRule, fullAdvertImgUrl, fullAdvertUrl }) {
  const key = `${TS_AD_SHOW_KEY}-${getUrlParam('shopId')}`;
  let show = false;
  // 每天显示一次
  const selectPeopleFlag = getSelectPeopleFlag() || {};
  if (fullAdvertRule === 1 && fullAdvertImgUrl) {
    // const last = window.localStorage.getItem(key);
    // const now = new Date();
    // const today = `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`;
    // const current = `${fullAdvertImgUrl}-${fullAdvertUrl}-${today}`;

    // if (!last || last !== current) {
    //   show = true;
    //   window.localStorage.setItem(key, current);
    // }
    const { dishNum, peopleNum } = selectPeopleFlag;
    if ((dishNum === 2 && peopleNum === 1) || dishNum === 1) {
      show = true;
    }
  }
  // 每次访问显示
  if (fullAdvertRule === 2 && fullAdvertImgUrl) {
    const hasShowed = window.sessionStorage.getItem(key);
    if (!hasShowed) {
      show = true;
      window.sessionStorage.setItem(key, 1);
    }
  }

  return show;
};

const getDishIds = function(dishes) {
  return dishes.reduce((list, dish) => {
    const spu = dish.productDishType === 1 && dish.dishList && dish.dishList.length;
    return spu ? list.concat(getDishIds(dish.dishList)) : list.concat(dish.dishId);
  }, []);
};

exports.getDishIds = getDishIds;

/**
 * 计算商品的基准价格
 * @param {Object} dish 商品对象
 */
const getDishBasePrice = function(dish) {
  const isSingleDish = isSingleDishWithoutProps(dish);
  const price = isSingleDish ? dish.marketPrice * dish.order : dish.marketPrice * dish.order[0].count;

  return price >= 0 ? price : 0;
};

exports.getDishBasePrice = getDishBasePrice;

/**
 * 计算商品列表的基准价格
 * @param {Array} dishes 商品列表
 */
const getDishesBasePrice = function(dishes) {
  return dishes.reduce((total, dish) => total + getDishBasePrice(dish), 0);
};

exports.getDishesBasePrice = getDishesBasePrice;

/**
 * 计算商品份数
 * @param {Array} dishes 商品列表
 */
const countDishesNumber = function(dishes) {
  return dishes.reduce((count, dish) => {
    const isSingleDish = isSingleDishWithoutProps(dish);
    return count + (isSingleDish ? dish.order : dish.order.reduce((t, c) => t + c.count, 0));
  }, 0);
};

exports.countDishesNumber = countDishesNumber;

/**
 * 将带有不同做法的商品平铺出来
 * @param {Array} dishes 购物车的商品列表
 */
const divideDishes = function(dishes, keyPrefix) {
  const prefix = keyPrefix ? `-${keyPrefix}_${new Date().getTime()}` : '';

  return [].concat.apply(
    [],
    dishes.map(dish => {
      if (isSingleDishWithoutProps(dish)) {
        return [
          {
            ...dish,
            basePrice: dish.marketPrice * dish.order,
            key: `${dish.brandDishId}${prefix}-0`,
          },
        ];
      }
      return dish.order.map((dishOrder, idx) => ({
        ...dish,
        key: `${dish.brandDishId}${prefix}-${idx}`,
        basePrice: dish.marketPrice * dishOrder.count,
        order: [{ ...dishOrder }],
        orderLength: dish.order.length,
      }));
    }),
  );
};

exports.divideDishes = divideDishes;

exports.mergeOrderedDishes = function(orderedDishes, selectedDishes) {
  // 去掉 immutable 属性
  const ordered = Immutable.asMutable(orderedDishes, { deep: true });
  // 新增的商品
  const newDishes = Immutable.asMutable(selectedDishes, { deep: true }).filter(dish => {
    const hadOne = ordered.find(item => item.brandDishId === dish.brandDishId);

    if (hadOne) {
      // 如果购物车中已经有这个商品；则更新它的订单属性
      hadOne.order = typeof hadOne.order === 'number' ? hadOne.order + dish.order : hadOne.order.concat(dish.order);
    }

    return !hadOne;
  });
  return ordered.concat(newDishes);
};

const getValueForDiscount = (originVal, discount) => +(originVal * discount * 0.1).toFixed(2);

/**
 * 计算属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @return {dishPropertyTypeInfos,dishIngredientInfos}
 */
const computePropsAndIngredientMemberRePrice = function(dish, discountValue, discountType) {
  const { dishPropertyTypeInfos, dishIngredientInfos } = dish;
  const res = { dishPropertyTypeInfos, dishIngredientInfos };
  if (discountType === MemberPrivTypes.DISCOUNT || discountType === MemberPrivTypes.UNIFIED_DISCOUNT) {
    if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
      res.dishPropertyTypeInfos = dishPropertyTypeInfos.map(prop => {
        const { properties } = prop;
        const newProperties = properties.map(item => {
          const { reprice = 0 } = item;
          return Object.assign({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
        });
        return Object.assign({}, prop, { properties: newProperties });
      });
    }

    if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
      res.dishIngredientInfos = dishIngredientInfos.map(ingredient => {
        const { reprice = 0 } = ingredient;
        return Object.assign({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
      });
    }
  }

  return res;
};

exports.computePropsAndIngredientMemberRePrice = computePropsAndIngredientMemberRePrice;

/**
 * 计算order中的属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @param {*} ableAddPriceDiscount 是否开启加价折扣
 * @return order
 */
const computeOrderMemberPrice = function(dish, discountValue, discountType, ableAddPriceDiscount = false) {
  const { order } = dish;
  if (typeof order === 'number') return order;

  if (Array.isArray(order)) {
    const newOrder = order.map(o => {
      let { dishPropertyTypeInfos, dishIngredientInfos } = o;
      // 只有开启折扣或者统一折扣 && 开启加价折扣 -> 口味做法才能打折
      if ((discountType === MemberPrivTypes.DISCOUNT || discountType === MemberPrivTypes.UNIFIED_DISCOUNT) && ableAddPriceDiscount) {
        if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
          dishPropertyTypeInfos = dishPropertyTypeInfos.map(prop => {
            const { properties } = prop;
            const newProperties = properties.map(item => {
              const { reprice = 0 } = item;
              return Object.assign({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
            });
            return Object.assign({}, prop, { properties: newProperties });
          });
        }

        if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
          dishIngredientInfos = dishIngredientInfos.map(ingredient => {
            const { reprice = 0 } = ingredient;
            return Object.assign({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
          });
        }
      }

      return {
        ...o,
        dishPropertyTypeInfos,
        dishIngredientInfos,
      };
    });
    return newOrder;
  }

  return dish.order;
};
exports.computeOrderMemberPrice = computeOrderMemberPrice;

/**
 * 计算group 中 order中的属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @param {*} ableAddPriceDiscount 是否开启加价折扣
 * @return order
 */
const computeGroupOrderMemberPrice = function(dish, discountValue, discountType, ableAddPriceDiscount = false) {
  const { order, isMember } = dish;
  // 只有折扣和统一折扣需要全部设置会员价  固定价只有group套餐外层memberPrice才需要修改，对内部子菜无影响
  if (discountType === MemberPrivTypes.DISCOUNT || discountType === MemberPrivTypes.UNIFIED_DISCOUNT) {
    const newOrder = order.map(o => {
      const { count, groups = [] } = o;
      const newGroups = groups.map(group => {
        const { childInfos = [] } = group;
        const newChildInfos = childInfos.map(child => {
          return {
            ...child,
            // memberMarketPrice: getDishMemberPrice({ isMember, ...child }, discountValue, discountType),
            // memberMarketPrice: getValueForDiscount(child.marketPrice, discountValue),
            memberMarketPrice: ableAddPriceDiscount ? getValueForDiscount(child.marketPrice, discountValue) : child.marketPrice,
            order: computeOrderMemberPrice({ isMember, ...child }, discountValue, discountType, ableAddPriceDiscount),
          };
        });
        return {
          ...group,
          childInfos: newChildInfos,
        };
      });

      return {
        ...o,
        groups: newGroups,
      };
    });

    return newOrder;
  }
  return order;
};
exports.computeGroupOrderMemberPrice = computeGroupOrderMemberPrice;

/**
 * 计算order中的属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @return {dishPropertyTypeInfos, dishIngredientInfos}
 */
const computeOrderPropsAndIngredientMemberRePrice = function(dish, discountValue, discountType) {
  const { dishPropertyTypeInfos, dishIngredientInfos } = dish;
  const res = { dishPropertyTypeInfos, dishIngredientInfos };
  if (discountType === MemberPrivTypes.DISCOUNT || discountType === MemberPrivTypes.UNIFIED_DISCOUNT) {
    if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
      res.dishPropertyTypeInfos = dishPropertyTypeInfos.map(prop => {
        const { properties } = prop;
        const newProperties = properties.map(item => {
          const { reprice = 0 } = item;
          return Object.assign({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
        });
        return Object.assign({}, prop, { properties: newProperties });
      });
    }

    if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
      res.dishIngredientInfos = dishIngredientInfos.map(ingredient => {
        const { reprice = 0 } = ingredient;
        return Object.assign({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
      });
    }
  }

  return res;
};

exports.computeOrderPropsAndIngredientMemberRePrice = computeOrderPropsAndIngredientMemberRePrice;

/**
 * 计算属性、配料等的会员价(套餐groups)
 * 各个子菜和子菜的口味做法 会员价
 * @param {*} groups
 * @param {*} discountValue
 * @param {*} discountType
 */
const computeMemberRePriceByGroups = function(groups, discountValue, discountType) {
  let result = groups;
  if (discountType === MemberPrivTypes.DISCOUNT || discountType === MemberPrivTypes.UNIFIED_DISCOUNT) {
    result = groups.flatMap(group => {
      const { childInfos } = group;
      if (Array.isArray(childInfos)) {
        const newChildInfos = childInfos.flatMap(child => {
          const { marketPrice } = child;
          const res = computePropsAndIngredientMemberRePrice(child, discountValue, discountType);
          res.memberMarketPrice = getValueForDiscount(marketPrice, discountValue);
          return Object.assign({}, child, res);
        });
        return Object.assign({}, group, { childInfos: newChildInfos });
      }
      return group;
    });
  }
  return result;
};

exports.computeMemberRePriceByGroups = computeMemberRePriceByGroups;

const getTotalMemberPriceBySingle = dish => {
  if (Immutable.isImmutable(dish)) {
    dish = Immutable.asMutable(dish, { deep: true });
  }
  const { order, saleType, memberMarketPrice, isMember } = dish;
  const isWeightMode = saleType === 1; // 称重模式
  let memberPrice = memberMarketPrice !== undefined && memberMarketPrice !== null ? memberMarketPrice : getDishMemberPrice(dish);
  memberPrice = memberPrice === null ? dish.marketPrice : memberPrice;
  let totalPrice = 0;

  if (Array.isArray(order)) {
    const { price, num } = order.reduce(
      (priceAndNum, item) => {
        const { price: oldPrice, num: oldNum } = priceAndNum;
        const { count, dishIngredientInfos, dishPropertyTypeInfos } = item;
        let diAmount = 0;
        let dpAmount = 0;
        if (Array.isArray(dishIngredientInfos)) {
          diAmount += dishIngredientInfos.reduce((ingredientPrice, ingredient) => {
            const { memberReprice, reprice, isChecked } = ingredient;
            const useMemberPrice = memberReprice !== undefined && memberReprice !== null;

            // return isChecked ? ingredientPrice + memberReprice : ingredientPrice;
            return isChecked ? ingredientPrice + (useMemberPrice ? memberReprice : reprice) : ingredientPrice;
          }, 0);
        }

        if (Array.isArray(dishPropertyTypeInfos)) {
          dishPropertyTypeInfos.forEach(propertyType => {
            const { properties } = propertyType;
            if (Array.isArray(properties)) {
              dpAmount += properties.reduce((proPrice, pro) => {
                const { isChecked, memberReprice, reprice } = pro;
                const useMemberPrice = memberReprice !== undefined && memberReprice !== null;

                // return isChecked ? proPrice + memberReprice : proPrice;
                return isChecked ? proPrice + (useMemberPrice ? memberReprice : reprice) : proPrice;
              }, 0);
            }
          });
        }

        const changeAmount = isWeightMode ? dpAmount + diAmount : (dpAmount + diAmount) * count;
        return { price: oldPrice + changeAmount, num: count + oldNum };
      },
      { price: 0, num: 0 },
    );
    totalPrice = memberPrice * num + price;
  } else if (!isNaN(order)) {
    totalPrice = memberPrice * order;
  }
  return +totalPrice.toFixed(2);
};

const getTotalMemberPriceByMulti = dish => {
  const { order, discountType } = dish;
  const oneBasePrice = getDishMemberPrice(dish); // 单份菜品基价价格
  let allCount = 0; // order中总分数
  let discountTotal = 0; // 加价部分总和
  if (Array.isArray(order)) {
    order.forEach(orderItem => {
      const { groups, count } = orderItem;
      allCount += count;
      groups.forEach(group => {
        const { childInfos } = group;
        childInfos.forEach(childInfo => {
          const { marketPrice, memberMarketPrice, order: childOrder } = childInfo;
          const allChildOrder = Array.isArray(childOrder) ? childOrder.reduce((total, item) => total + item.count, 0) : childOrder;
          const singlePrice = getTotalMemberPriceBySingle(childInfo);
          const basePrice = allChildOrder * (memberMarketPrice >= 0 ? memberMarketPrice : marketPrice);
          const childPrice =
            discountType === MemberPrivTypes.REDUCE
              ? // (singlePrice + basePrice) :
                singlePrice // 修改会员价加价不折扣后不需要加basePrice
              : singlePrice;
          discountTotal += childPrice * count;
        });
      });
    });
  } else if (!isNaN(order)) {
    allCount = Number(order);
  }
  const allPrice = oneBasePrice * allCount + discountTotal;
  return +allPrice.toFixed(2);
};

/**
 * 获取菜品的会员价+口味做法会员价
 * 这个方法适用于已经将口味做法的会员价写入dish的菜品
 * memberRePrice
 * @param {*} dish
 */
const getTotalMemberPrice = dish => {
  const { type } = dish;
  let res = 0;
  if (type === 1) {
    res = getTotalMemberPriceByMulti(dish);
  } else {
    res = getTotalMemberPriceBySingle(dish);
  }

  return res;
};

exports.getTotalMemberPrice = getTotalMemberPrice;

/**
 * 根据dish 算出口味做法，配料以及套餐的会员价
 * @param {*} dish
 * @param {*} discountVal
 * @param {*} discountType
 */
const getPropAndIngredientMemberPrice = (dish, discountVal, discountType) => {
  const { groups } = dish;
  const result = computePropsAndIngredientMemberRePrice(dish, discountVal, discountType);
  let newGroups = groups;
  if (Array.isArray(groups)) {
    newGroups = computeMemberRePriceByGroups(groups, discountVal, discountType);
  }
  return {
    groups: newGroups,
    dishPropertyTypeInfos: result.dishPropertyTypeInfos,
    dishIngredientInfos: result.dishIngredientInfos,
  };
};

exports.getPropAndIngredientMemberPrice = getPropAndIngredientMemberPrice;

/**
 * 获取菜品的会员价+口味做法会员价购物车所选菜品之和
 * memberRePrice
 * @param {*} dishs
 * @param {*} ableAddPriceDiscount
 */
exports.getMemberDishesPrice = (dishes = [], ableAddPriceDiscount = false) => {
  const dishesPrice = dishes.reduce((all, cur) => {
    const memberPriceStr = cur.isMember && cur.memberPrice !== null ? cur.memberPrice.toString() : null; // 消除memberPrice为0的影响
    // const isUseAddDiscount = cur.isMember && cur.isUserMember && memberPriceStr && ableAddPriceDiscount;
    // if (isUseAddDiscount) return all + getTotalMemberPrice(cur);
    // return all + getDishesPrice([cur], null, true);
    // return all + getDishesPrice([cur], null, cur.isMember);

    const useAddDiscount =
      (cur.discountType === MemberPrivTypes.UNIFIED_DISCOUNT || cur.discountType === MemberPrivTypes.DISCOUNT) &&
      cur.isMember &&
      cur.isUserMember &&
      memberPriceStr &&
      ableAddPriceDiscount;
    const useMemberPrice = cur.isMember && cur.isUserMember && memberPriceStr;
    if (useAddDiscount) {
      return all + getTotalMemberPrice(cur);
    } else if (!!useMemberPrice) {
      return all + getTotalMemberPrice(cur);
    }
    return all + getDishesPrice([cur], null, cur.isMember);
  }, 0);

  if (isFinite(dishesPrice) && Math.floor(dishesPrice) === dishesPrice) {
    return dishesPrice;
  }
  return parseFloat(dishesPrice.toFixed(2));
};

/**
 * 变价享受会员价。
 * 该方法主要是更改order
 * @param {*} order
 * @param {*} discountValue
 * @param {*} discountType
 */
const reConstructDishOrder = (order, discountValue, discountType) => {
  let res = order;

  if (Array.isArray(order)) {
    if (Immutable.isImmutable(order)) {
      res = Immutable.asMutable(order, { deep: true });
    }
    res = res.map(orderItem => {
      const { groups, dishIngredientInfos, dishPropertyTypeInfos } = orderItem;
      const newOrderItem = { ...orderItem };
      if (discountType === MemberPrivTypes.DISCOUNT || discountType === MemberPrivTypes.UNIFIED_DISCOUNT) {
        if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
          newOrderItem.dishPropertyTypeInfos = dishPropertyTypeInfos.map(prop => {
            const { properties } = prop;
            const newProperties = properties.map(item => {
              const { reprice = 0 } = item;
              return Object.assign({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
            });
            return Object.assign({}, prop, { properties: newProperties });
          });
        }

        if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
          newOrderItem.dishIngredientInfos = dishIngredientInfos.map(ingredient => {
            const { reprice = 0 } = ingredient;
            return Object.assign({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
          });
        }

        if (Array.isArray(groups)) {
          newOrderItem.groups = groups.map(group => {
            const { childInfos } = group;
            const newChildInfos = Array.isArray(childInfos)
              ? childInfos.map(child => {
                  const { order: subOrder, marketPrice } = child;
                  // const memberMarketPrice = getValueForDiscount(marketPrice, discountValue) || marketPrice || 0;
                  const memberMarketPrice = getValueForDiscount(marketPrice, discountValue) || 0;
                  return {
                    ...child,
                    memberMarketPrice,
                    order: reConstructDishOrder(subOrder, discountValue, discountType),
                  };
                })
              : childInfos;

            return { ...group, childInfos: newChildInfos };
          });
        }
      }

      return newOrderItem;
    });
  }
  return res;
};

exports.reConstructDishOrder = reConstructDishOrder;

/**
 * 将菜品信息中的会员价 写入正价，用于计算
 * @param {*} dish
 */
const covertMemberPriceInDish = dish => {
  const { order, memberMarketPrice, discountType, isMember } = dish;
  const newMarketPrice =
    memberMarketPrice !== null && memberMarketPrice !== undefined ? memberMarketPrice : getDishMemberPrice({ isMember, discountType, ...dish });

  let newOrder = order;
  if (Array.isArray(order)) {
    newOrder = order.map(orderItem => {
      const result = { ...orderItem };
      const { groups, dishIngredientInfos, dishPropertyTypeInfos } = orderItem;
      let newGroups = groups;
      if (Array.isArray(groups) && groups.length > 0) {
        newGroups = groups.map(group => {
          const { childInfos } = group;
          const newChildInfos = childInfos.map(child => {
            // return covertMemberPriceInDish(child);
            if (discountType === MemberPrivTypes.REDUCE) {
              // 2 套餐中的菜品不受整个套餐立减的影响
              return covertMemberPriceInDish({ memberMarketPrice: child.marketPrice, ...child });
            }
            return covertMemberPriceInDish({ isMember, discountType, ...child });
          });

          return {
            ...group,
            childInfos: newChildInfos,
          };
        });

        result.groups = newGroups;
      } else {
        if (Array.isArray(dishIngredientInfos)) {
          const diAry = dishIngredientInfos.map(di => {
            const { memberReprice, reprice } = di;
            // return { ...di, reprice: memberReprice || reprice };
            return { ...di, reprice: memberReprice >= 0 ? memberReprice : reprice }; // 消除memberReprice为0的影响
          });
          result.dishIngredientInfos = diAry;
        }

        if (Array.isArray(dishPropertyTypeInfos)) {
          const dpAry = dishPropertyTypeInfos.map(dp => {
            const { properties } = dp;
            const r = { ...dp };
            if (Array.isArray(properties)) {
              const newProperties = properties.map(prop => {
                const { memberReprice, reprice } = prop;
                // return { ...prop, reprice: memberReprice || reprice };
                return { ...prop, reprice: memberReprice >= 0 ? memberReprice : reprice }; // 消除memberReprice为0的影响
              });
              r.properties = newProperties;
            }
            return r;
          });
          result.dishPropertyTypeInfos = dpAry;
        }
      }

      return result;
    });
  }
  return {
    ...dish,
    marketPrice: newMarketPrice,
    order: newOrder,
  };
};

exports.covertMemberPriceInDish = covertMemberPriceInDish;

// 获取必点菜的最小数量以及其提示语
const getMustOrderMinNum = ({ strategyType, strategyValue, mustSelect, dishIncreaseUnit, clearStatus }, selfChooseCount = 0) => {
  // 加菜模式就不用开台必点的属性了
  const orderId = getUrlParam('orderId');
  const type = getUrlParam('type');
  const formal = isFormalMeal(Number(sessionStorage.getItem('diningForm'))) && type !== 'WM';

  if (orderId || !formal) {
    return {
      minimum: 0,
      msg: {},
    };
  }

  // 必点菜且未估清的状态
  const minimum =
    mustSelect && !clearStatus
      ? strategyType === 1
        ? Math.max(dishIncreaseUnit, strategyValue)
        : strategyType === 2
        ? Math.max(dishIncreaseUnit, strategyValue)
        : strategyType === 3
        ? selfChooseCount
        : 0
      : 0;
  const minimumMsg =
    strategyType === 3 && minimum
      ? formatMessage(dishMenuMessages.selfChooseCannotLess, { value: minimum })
      : formatMessage(dishMenuMessages.mustOrderCannotLess, { value: minimum });
  const msg =
    mustSelect && !clearStatus
      ? {
          minimumMsg,
        }
      : null;

  return {
    minimum,
    msg,
  };
};

exports.getMustOrderMinNum = getMustOrderMinNum;

// 设置菜品列表的必点菜属性
const setDishListMustOrderProps = (dishList = [], mustOrderDishList) =>
  dishList.map(item => {
    const { mustSelect = false, strategyType, strategyValue } = mustOrderDishList.find(mustItem => mustItem.id === item.id) || {};

    return {
      ...item,
      mustSelect,
      strategyType,
      strategyValue,
    };
  });

exports.setDishListMustOrderProps = setDishListMustOrderProps;

// 设置协同购物车过来的用户的菜品列表的必点菜属性
const setUserOrderedDishListMustOrderProps = (userOrderedDishList = [], mustOrderDishList = []) =>
  userOrderedDishList.map(({ dishList = [], ...rest }) => ({
    dishList: setDishListMustOrderProps(dishList, mustOrderDishList),
    ...rest,
  }));

exports.setUserOrderedDishListMustOrderProps = setUserOrderedDishListMustOrderProps;

// 是否叠加，算出可以获赠多少份商品
const getSuperimpose = function(benefit, dishes) {
  const { stackRule, matched, marketRuleDtos } = benefit;
  let superimpose = 0;
  if (stackRule && matched && marketRuleDtos && marketRuleDtos[0] && marketRuleDtos[0].policySubjectId === 12) {
    const { ruleSubjectId, policyValue1, logicValue } = marketRuleDtos[0];

    // 满量
    if (ruleSubjectId === 11) {
      superimpose = Math.floor(countDishesNumber(dishes) / logicValue) * policyValue1;
    }
    // 满额
    if (ruleSubjectId === 12) {
      superimpose = Math.floor(getDishesBasePrice(dishes) / logicValue) * policyValue1;
    }
  }

  return superimpose;
};

/**
 * 满赠 把活动商品转为普通商品的数据格式
 * @param {*} dish
 */
const turnpolicyDishesToDishes = policyDishes => {
  const dishes = policyDishes
    .reduce((list, item) => {
      const { dishType, midDishes } = item;
      return list.concat(dishType === 1 ? item : midDishes);
    }, [])
    .map(dish => ({
      ...dish,
      residueTotal: dish.saleableNum,
      name: dish.dishName,
      smallImgUrl: dish.icon,
      marketPrice: dish.price,
      brandDishId: dish.dishId,
      dishId: dish.dishShopId, // 后端传值混乱
    }));
  return dishes;
};
exports.turnpolicyDishesToDishes = turnpolicyDishesToDishes;

/**
 * 满赠 生成需要被默认选上的赠品份数
 * @param {*} dish
 * @param {*} limit 最多选几分
 */

const selectDefaultGiveDish = (benefitDishe, limit = 1) => {
  let dish = JSON.parse(JSON.stringify(benefitDishe));
  const isSingle = isSingleDishWithoutProps(benefitDishe);
  const count = Number(limit);
  let order = null;
  if (isSingle) {
    order = count;
  } else {
    order = [
      {
        count,
        dishIngredientInfos: dish.dishIngredientInfos,
        dishPropertyTypeInfos: dish.dishPropertyTypeInfos,
      },
    ];
  }
  dish = {
    ...dish,
    count,
    order,
  };
  return dish;
};
exports.selectDefaultGiveDish = selectDefaultGiveDish;

/**
 * 满赠 默认选中赠品如果有必选做法 则默认选中第一个
 * @param {*} dish
 */
const selectFirstIngredient = eslectedDish => {
  const dish = JSON.parse(JSON.stringify(eslectedDish));
  const { dishPropertyTypeInfos = [] } = dish;
  dishPropertyTypeInfos.forEach(item => {
    const { isMandatory = 0, properties = [] } = item;
    const checkedProperties = properties.filter(p => p.isChecked);
    // 必选 && 没有默认 则默认选中第一个
    if (isMandatory === 1 && !checkedProperties.length) {
      properties[0].isChecked = true;
    }
  });
  return dish;
};

/**
 * 满赠 默认选中赠品
 * @param {*} state
 * @param {*} FULL_PROMOTIONS 满赠
 */
const selectDefaultGiveDishes = (state, FULL_PROMOTIONS = 'fullPromotions') => {
  try {
    const { allBenefits = {}, divideDishes: divideDishList } = state;

    const list = allBenefits[FULL_PROMOTIONS];
    const fullPromitionList = JSON.parse(JSON.stringify(list));
    fullPromitionList.forEach(currentBenefit => {
      const { matched, dishKeys, benefitDishes } = currentBenefit;
      const { policyValue1, policyValue2, policySubjectId } = (currentBenefit.marketRuleDtos && currentBenefit.marketRuleDtos[0]) || {};
      // 满赠(policySubjectId 12为满赠) && 符合满赠条件 && 有菜品 && 赠品为空  -> 默认选中赠品
      if (policySubjectId === 12 && matched && dishKeys.length && !benefitDishes.length) {
        // 默认选中活动商品的第一个
        const policyDishes = currentBenefit.policyDishes && currentBenefit.policyDishes.length ? currentBenefit.policyDishes[0] : [];
        // 需要把活动商品转为普通商品的数据格式
        const dishes = turnpolicyDishesToDishes([policyDishes]);
        // 默认选中第一个赠送商品
        let benefitDishe = dishes.length ? dishes[0] : [];
        // console.log('---benefitDishe---', benefitDishe);
        // 如果做法有必选 则默认选中第一个必选做法
        benefitDishe = selectFirstIngredient(benefitDishe);
        // console.log('---默认选中第一个赠送商品 benefitDishe---', benefitDishe);
        const targetDishes = divideDishList.filter(dish => currentBenefit.dishKeys.indexOf(dish.key) > -1);

        // 是否叠加的参数，算出可以获赠多少份商品 limit
        const superimpose = getSuperimpose(currentBenefit, targetDishes);
        // const { policyValue1, policyValue2, policySubjectId } = (currentBenefit.marketRuleDtos && currentBenefit.marketRuleDtos[0]) || {};
        const limit = superimpose || (policySubjectId === 12 ? policyValue1 : policyValue2);

        // 生成需要被默认选上的赠品
        benefitDishe = selectDefaultGiveDish(benefitDishe, limit);
        currentBenefit.benefitDishes = divideDishes([benefitDishe], 'benefit_dishes');
      }
    });
    return fullPromitionList;
  } catch (e) {
    console.warn(`满赠 ${e.message}`);
    return state.allBenefits[FULL_PROMOTIONS];
  }
};

exports.selectDefaultGiveDishes = selectDefaultGiveDishes;

/**
 * 再来一单 - 多规格菜品 order合并
 * @param {*} dish 后端再来一单烦恼会的dish
 */
const getAnthorOrder = (dish) => {
  const { order = [], dishIngredientInfos = [], dishPropertyTypeInfos = [] } = dish;
  const newOrder = order.reduce((all, cur) => {
    const {
      dishIngredientInfos: _dishIngredientInfos = [],
      dishPropertyTypeInfos: _dishPropertyTypeInfos = [],
    } = cur;
    const newIngredient = dishIngredientInfos.map(ing => {
      const _ing = _dishIngredientInfos.filter(d => d.id === ing.id);
      if (_ing.length) {
        return {
          ...ing,
          ..._ing[0],
        };
      }
      return ing;
    });
    const newProperty = dishPropertyTypeInfos.map(pro => {
      const _pro = _dishPropertyTypeInfos.filter(d => d.id === pro.id);
      if (_pro.length) {
        const { properties = [] } = pro;
        const { properties: _properties = [] } = _pro[0];
        const newproperties = properties.map(p => {
          const _p = _properties.filter(d => d.id === p.id);
          if (_p.length) {
            return {
              ...p,
              ..._p[0],
            };
          }
          return p;
        });
        return {
          ...pro,
          properties: newproperties,
        };
      }
      return pro;
    });
    return all.concat({ ...cur, dishIngredientInfos: newIngredient, dishPropertyTypeInfos: newProperty });
  }, []);
  return newOrder;
};
exports.getAnthorOrder = getAnthorOrder;



// WEBPACK FOOTER //
// ./src/helper/dish-helper.js